import FinancialStatementsProvider from './FinancialStatementsProvider';

export default FinancialStatementsProvider;
